import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { DistributionList } from './distribution-list.model';
import { User } from './user.model';

@Injectable()
export class DistributionListsService {

  apiHost = environment.apiHost;
  signedIn: boolean = this.authService.signedIn;
  currentUser: User = this.authService.currentUser;
 
  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getLists(page: number, search?: string, workflowId?: number, userOnly?: boolean): Observable<any> {
    let query = "?page="+page+"&result_size=10&user_only=" + (userOnly === true)
    if (search != null) {
      query += "&name=" + encodeURIComponent(search);
    }
    if (workflowId != null) {
      query += "&wf_id=" + workflowId;
    }
    return this.http.get(this.apiHost+"/distributionlist"+query).map(
      (data: any) => {
        let listData = data.lists != null ? data.lists : data.slice((page-1)*10,page*10);
        let total = data.total_lists != null ? data.total_lists : data.length;
        let lists = listData.map((l) => DistributionList.fromRecord(l))
        return {lists: lists, total: total};
      }
    ).catch((error) => {
        console.log("Get lists error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  createList(list: DistributionList): Observable<any> {
    let payload: any = {
      "name": list.name,
      "users": list.users.map((u) => {
        return {
          user_id: u.id,
          user_email: u.email,
          user_first: u.firstName,
          user_last: u.lastName
        }
      }),
      "public": (list.isPublic === true)
    }
    if (list.isPublic) {
      payload["workflow_ids"] = list.workflowIds;
    }
    if (this.currentUser != null) {
      payload["author"] = {
        "user_id": this.currentUser.id,
        "user_email": this.currentUser.email,
        "user_first": this.currentUser.firstName,
        "user_last": this.currentUser.lastName
      }
    }
    return this.http.post(this.apiHost+"/distributionlist", payload).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Create list error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        let message = error.json().message;
        return Observable.throw(new Error(message));
      }
    );
  }

  updateList(list: DistributionList): Observable<any> {
    let payload = {
      "name": list.name,
      "users": list.users.map((u) => {
        return {
          user_id: u.id,
          user_email: u.email,
          user_first: u.firstName,
          user_last: u.lastName
        }
      }),
      "public": (list.isPublic === true),
      "workflow_ids": list.workflowIds
    }
    if (this.currentUser != null) {
      payload["author"] = {
        "user_id": this.currentUser.id,
        "user_email": this.currentUser.email,
        "user_first": this.currentUser.firstName,
        "user_last": this.currentUser.lastName
      }
    }
    return this.http.put(this.apiHost+"/distributionlist/"+list.id, payload).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Update list error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        let message = error.json().message;
        return Observable.throw(new Error(message));
      }
    );
  }

  deleteList(list: DistributionList): Observable<any> {
    return this.http.delete(this.apiHost+"/distributionlist/"+list.id).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Delete list error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(new Error(error.status));
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/users/distribution-lists.service.ts